// src/app/slices/reportSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
});

export const {} = reportSlice.actions;

export default reportSlice.reducer;
